import { render, staticRenderFns } from "./ForgotMembershipRoute.vue?vue&type=template&id=5cda59f0&"
import script from "./ForgotMembershipRoute.vue?vue&type=script&lang=ts&"
export * from "./ForgotMembershipRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports